const pcninfo = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "PCN Information",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4",
        children: [
          {
            title: "PCN Information",
            service: "pages",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: true,
              deleteButton: false,
              activeLimit: 8,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Label",
                    placeholder: "Enter Label",
                    required: true,
                    info: true,
                    character_count: 40,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  color: "#715bff",
                  icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/building.svg",
                  action: "Link",
                  link_url: "",
                  label: "hello",
                },
              },
            },
            children: [
              {
                type: "quickLinksTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Links",
                  // "type": "list",
                  type: "list",
                  // "variant": "filtered",
                  filter: "labels",
                  filterOn: "group",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pr-3 pt-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    preview: {
                      type: "practiceInfoPreview",
                      label: "Preview",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    title: {
                      type: "text",
                      label: "Name",
                      placeholder: "Enter Label",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: true,
                      class: "mr-2",
                      size: "6",
                      style: "",
                    },
                    label: {
                      type: "text",
                      label: "Label",
                      placeholder: "Enter Label",
                      required: false,
                      info: false,
                      character_count: 40,
                      disabled: false,
                      class: "mr-5",
                      size: "6",
                      style: "",
                    },
                    action: {
                      type: "select",
                      label: "Action",
                      placeholder: "Select Action",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["Link", "Dropdown"],
                    },
                    link_url: {
                      type: "text",
                      label: "Link",
                      displayOn: "action",
                      displayOnValue: "Link",
                      placeholder: "Enter Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { pcninfo };
